import { ExperimentsExtension } from '@wix/premium-fed-sdk-kit/@extensions';
export const StudioExperimentsExtension = ExperimentsExtension({
  scope: 'premium-purchase-plan'
});
//# sourceMappingURL=studio-experiments.extension.js.map